import { isString } from "lodash";
import { i18n } from "../translate/i18n";

const backendErrorCode = err => {
  const responseError = err?.response?.data?.error;
  if (isString(responseError)) return responseError;
  if (responseError?.code) return responseError.code;
  if (responseError?.message) return responseError.message;
  return null;
};

export function translateBackendError(err, fallback) {
  const backendError = backendErrorCode(err);
  if (backendError && i18n.exists(`backendErrors.${backendError}`)) {
    return i18n.t(`backendErrors.${backendError}`);
  }
  return fallback;
}
